(ns frontend.view.modals.account-edit.view
  (:require
   [common.email :as email]
   [common.localization :as loc]
   [common.roles :as roles]
   [common.util :as cu]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.view.modals.account-edit.events :as events]
   [ui.editors.labelled-input.view :as labelled-input]
   [frontend.view.modals.components.processing-modal :as processing-modal]
   [ui.components.modal.view :as modal]
   [ui.components.radio-group.view :as radio-group]))

(defonce modal-key :account-edit)

(defn view-body
  [state other-accounts-lcase-emails role mandatory?]
  (let [options (->> [:role/user :role/admin]
                     (map (fn [p]
                            {:value   p
                             :content (loc/tr p)})))]

    [:div
     {:class "flex flex-column gap-4"}
     [labelled-input/view
      {:label     (str (loc/tr :tenant-users/first-name)
                       (when mandatory?
                         [:span.mandatory " *"]))
       :data-type :data.type/text-simple
       :value     (get @state :first-name)
       :mandatory? true
       :on-change (fn [new-value]
                    (swap! state assoc :first-name new-value))}]
     [labelled-input/view
      {:label (loc/tr :tenant-users/last-name)
       :data-type :data.type/text-simple
       :value     (get @state :last-name)
       :on-change (fn [new-value]
                    (swap! state assoc :last-name new-value))}]

     [:div
      [labelled-input/view
       {:label (loc/tr :tenant-users/email)
        :data-type :data.type/text-simple
        :disabled? true
        :value     (get @state :email)
        :on-change (fn [new-value]
                     (swap! state assoc :email new-value))}]
      [:p {:class "text-xs"}
       (cond
         (empty? (fu/trimmed-lower-case (get @state :email)))
         (loc/tr :error-field-not-clearable [(loc/tr :email)])

         (not (email/valid-email-pattern? (get @state :email)))
         (loc/tr :account-email-not-valid)

         (some #{(fu/trimmed-lower-case (get @state :email))} other-accounts-lcase-emails)
         (loc/tr :email-exists-on-other-account))]]
     (when-not (roles/is-guest-role? role)
       [:div
        [:div
         {:class "pb-2 text-[14px] text-input-light-text font-semibold"}
         (loc/tr :role) false]
        [radio-group/radio-group-v2
         {:checked   (:role-kw @state)
          :orientation :vertical
          :on-change (fn [value]
                       (swap! state assoc :role-kw value))}
         options]]

        ;;  [:div.zap-form__light-grey__green__sand.form__text.form-group.mb-0
        ;;   [:div.form-group__content
        ;;    [label/view (loc/tr :role) false]
        ;;    [:div.radio
        ;;     [:label
        ;;      {:class-name "zap-inlined-radiobox-label"}
        ;;      [:input
        ;;       {:type       "radio"
        ;;        :class-name "zap-inlined-radiobox__green"
        ;;        :disabled   (= (:db/id @session/account) account-id)
        ;;        :name       "new-user-role"
        ;;        :checked    (= :role/user (:role @state))
        ;;        :on-change  (fn [e]
        ;;                      (swap! state assoc :role :role/user))}]
        ;;      [:span {:class-name "radiomark"}]
        ;;      (loc/tr :role/user)]]
        ;;    [:div.radio.mb-0
        ;;     [:label
        ;;      {:class-name "zap-inlined-radiobox-label"}
        ;;      [:input
        ;;       {:type       "radio"
        ;;        :class-name "zap-inlined-radiobox__green"
        ;;        :name       "new-user-role"
        ;;        :disabled   (= (:db/id @session/account) account-id)
        ;;        :checked    (= :role/admin (:role @state))
        ;;        :on-change  (fn [e]
        ;;                      (swap! state assoc :role :role/admin))}]
        ;;      [:span {:class-name "radiomark"}]
        ;;      (loc/tr :role/admin)]]]]
       )])
  )

(defn footer-view
  [edit? state on-close! account role button-text on-submit!]
  (let [role-kw (:role/role role)
        ready? (events/form-ready? state account role)
        unsaved-changes? (events/unsaved-changes? state account role-kw)]
    [modal/right-single-button
     nil
     (or (not ready?)
         (and edit?
              (not unsaved-changes?)))
     (fn [_]
       (events/modify-account! state
                               (:db/id account)
                               (:db/id role)
                               false
                               on-close!
                               on-submit!))
     (or button-text
         (if edit?
           (loc/tr :save)
           (loc/tr :reinvite)))
     nil]))

(defn view
  [{:keys [shown? close-modal! props state class-name topmost?]}]
  (let [{:keys [account-id role-id title submit-button-text success-message
                on-submit! on-close!]}
        props
        on-close! (fn []
                    (when on-close!
                      (on-close!))
                    (close-modal!))
        all-accounts @session/all-accounts
        account (->> all-accounts
                     (cu/filter-by :db/id account-id)
                     (first))
        other-accounts (remove #(= account %) all-accounts)
        other-accounts-lcase-emails (->> other-accounts
                                         (map :account/email)
                                         (map fu/trimmed-lower-case))
        role (get @session/entities role-id)
        edit? (not (:common/disabled? role))]
    [processing-modal/render-modal
     {:state            state
      :shown?           (and shown? topmost?)
      :success-text     (or success-message (loc/tr :success-account-modified))
      :on-close!        on-close!
      :class-name       class-name
      :on-show!         (fn []
                          (swap! state assoc
                                 :email (:account/email account)
                                 :first-name (:account/first-name account)
                                 :last-name (:account/last-name account)
                                 :role-kw (:role/role role)))
      :default-title-fn (fn []
                          (or title
                              (loc/tr :edit-user-details [(:account/email account)])))
      :default-body-fn  (partial view-body
                                 state
                                 other-accounts-lcase-emails
                                 (:role/role role))
      :default-footer-fn
      (partial footer-view edit? state on-close! account role submit-button-text on-submit!)}]))
